import axios from 'axios';
import { getAuthHeader } from './authApi';
import { UserPoints } from './usersApi';

export interface SideBet {
  id: number;
  name: string;
  user_ids: number[];
}

export interface SideBetPayload {
  name: string;
  user_ids: number[];
}

export const getSideBets = async (): Promise<SideBet[]> => {
  try {
    const res = await axios.get('/api/side-bets', { headers: getAuthHeader() });
    return res.data || [];
  } catch (error) {
    console.error('Error fetching side bets', error);
    return [];
  }
};

export const createSideBet = async (payload: SideBetPayload): Promise<SideBet> => {
  const res = await axios.post('/api/side-bets', payload, { headers: getAuthHeader() });
  return res.data;
};

export const updateSideBet = async (id: number, payload: SideBetPayload): Promise<SideBet> => {
  const res = await axios.put(`/api/side-bets/${id}`, payload, { headers: getAuthHeader() });
  return res.data;
};

export const deleteSideBet = async (id: number): Promise<SideBet> => {
    const res = await axios.delete(`/api/side-bets/${id}`,{ headers: getAuthHeader() });
    return res.data;
  };

export const getSideBetPoints = async (id: number): Promise<UserPoints[]> => {
  try {
    const res = await axios.get(`/api/side-bets/${id}/points`, { headers: getAuthHeader() });
    return res.data || [];
  } catch (error) {
    console.error(`Error fetching side bet ${id} points`, error);
    return [];
  }
};

